// Browser-tab context only. The backend verifies chat ownership and provenance.
let activeChatSessionId = null;
export const getBranchPreviewChatSession = () => activeChatSessionId;
export const setBranchPreviewChatSession = (sessionId) => {
  activeChatSessionId = sessionId || null;
};
